'use client'

import { useState, useEffect } from 'react'
import { useAccount } from 'wagmi'

import ConnectWalletButton from '../ConnectWalletButton'
import MarketContent from '../../views/Home/MarketContent'

const WalletProtect = ({ children }) => {
  const { isConnected } = useAccount()
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) return null

  return !isConnected ? (
    <>
      <div className="card mt-8 h-heroMd bg-[url('/image/hero.png')] bg-cover bg-center ">
        <div className="flex h-full flex-col items-center justify-center p-8 ">
          <h1 className="text-center text-4xl font-bold text-white-1 sm:text-[40px]">Please connect your wallet</h1>
          <div className="justify-center p-8">
            <ConnectWalletButton noIcon />
          </div>
        </div>
      </div>
      <MarketContent />
    </>
  ) : (
    children
  )
}

export default WalletProtect
